import {I18N_VALUE_CODE_KEY, I18N_VALUE_HELP_MESSAGE_KEY} from "lf-at-theme";

/**
 * intermediary form i18n object for the en-US locale.
 */

export const intermediaryFormI18nEnUS: Record<string, any> = {
  '/intermediary-form': {
    label: 'Registration as Intermediary',
  },

  '/?/meetsConditions': {
    label: 'I confirm that I meet the conditions to register for this scheme.'
  },


  '/?/currVatId': {
    netpVat: 'Intermediary Number',
    netpHelp: 'Individual identification number allocated by the Member State of identification in accordance with Article 369q(2) of Directive 2006/112/EC',
  },
  '/?/currVatId/vatIdNum': {
    legend: 'Filled-in by the system after approval'
  },

  '/?/identificationOfBusiness': {
    label: 'VAT Identification Number',
  },
  '/?/identificationOfBusiness/issuingCountry': {
    [I18N_VALUE_CODE_KEY]: '2a',
  },

  '/?/identificationOfBusiness/vatIdNum': {
    legend: 'Filled-in by the system'
  },

  '/?/countryOfBusiness': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'The Member State in which the intermediary has his place of business or, in the absence of a place of business in the Union, the Member State in which the intermediary has a fixed establishment where he indicates that he will make use of the import scheme on behalf of the taxable person(s) he represents'
  },

  '/?/contactInfo/email': {
    label: 'Email address of the intermediary'
  },

  '/?/fixedEstablishments/?/taxIdentif/vatIdNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Individual VAT identification number(s) or, if not available, tax reference number(s) allocated by the Member State(s) in which the taxable person has a fixed establishment(s) other than the Member State of identification.'
  },

  '/?/fixedEstablishments/?/taxIdentif/taxRefNum': {
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Tax Reference Number given by the Member State'
  },

  '/?/prevOrCurrOssVatId': {
    headerText: 'Registration as Intermediary in other Member States',
    [I18N_VALUE_HELP_MESSAGE_KEY]: 'Intermediary number(s) allocated by the Member State of identification in accordance with Article 369q(2) of Directive 2006/112/EC'
  },

  '/?/relevantDates/registrationReqDate': {
    label: 'Date of request to be registered as an intermediary',
    [I18N_VALUE_HELP_MESSAGE_KEY]: null
  },
};
